import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function ExtraForBooking() {
    return (
        <>
            <Box sx={{ py: 5, bgcolor: 'rgba(0,0,0, .2)' }}>

                <Container sx={{ justifyContent: 'center', alignContent: 'center', alignItems: 'center', flexDirection: 'column', display: 'flex' }} >
                    <Box sx={{ color: '#fff', fontSize: '16px', fontWeight: 500, width: '60%', pt: 3, pr: 6 }}>
                        ANYTHING ELSE FOR YOUR BOOKING
                    </Box>
                    <Paper sx={{ width: '60%', p: 3, bgcolor: '#fff', m: 3, display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                        <Box sx={{ width: '180px', display: 'flex' }}>
                            <Box sx={{
                                borderRadius: '10px',
                                bgcolor: '#d93e45',
                                height: '150px',
                                width: '150px',
                                position: 'relative',
                                right: '50px',
                                margin: 'auto',
                                verticalAlign: 'middle',
                                backgroundImage: `url('/images/myxpery-side.png')`,
                                backgroundSize: 'contain',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                display: 'inline-block'
                            }}>

                            </Box>
                        </Box>
                        <Box sx={{ width: 'calc(100%-200px)' }}>
                            <Box sx={{ fontSize: '14px', fontWeight: 500, pb: 1 }}>
                                AIRPORT TRANSFER
                            </Box>
                            <Box sx={{ fontSize: '12px', fontWeight: 300 }}>
                                Online check-in is free. If you wish to check in at the airport, add this service to your booking.
                                <br />
                                <Typography sx={{ color: '#d93e45', fontSize: '12px', fontWeight: 600, pt: 1 }}>Details</Typography>
                            </Box>
                            <Box>
                                <Grid sx={{ textAlign: 'center', py: 2 }} spacing={2} container>
                                    <Grid item>
                                        <Box sx={{ fontWeight: 500, fontSize: '14px', px: 5, py: 1 }}>
                                            Budapest
                                        </Box>
                                        <Box sx={{ fontWeight: 700, fontSize: '14px', borderRadius: '20px', border: '1px solid #333', p: 1 }}>
                                            3650 Ft
                                        </Box>
                                    </Grid>
                                    <Grid item>
                                        <Box sx={{ fontWeight: 500, fontSize: '14px', px: 5, py: 1 }}>
                                            Tirana
                                        </Box>
                                        <Box sx={{ fontWeight: 700, fontSize: '14px', borderRadius: '20px', border: '1px solid #d93e45', p: 1 }}>
                                            Díjmentes
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Paper>
                    <Paper sx={{ width: '60%', p: 3, bgcolor: '#fff', m: 3, display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                        <Box sx={{ width: '180px', display: 'flex' }}>
                            <Box sx={{
                                borderRadius: '10px',
                                bgcolor: '#d93e45',
                                height: '150px',
                                width: '150px',
                                position: 'relative',
                                right: '50px',
                                margin: 'auto',
                                verticalAlign: 'middle',
                                backgroundImage: `url('/images/myxpery-side.png')`,
                                backgroundSize: 'contain',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                display: 'inline-block'
                            }}>

                            </Box>
                        </Box>
                        <Box sx={{ width: 'calc(100%-200px)' }}>
                            <Box sx={{ fontSize: '14px', fontWeight: 500, pb: 1 }}>
                                FAST TRACK
                            </Box>
                            <Box>
                                <Grid sx={{ textAlign: 'center', py: 1 }} spacing={2} container>
                                    <Grid item>
                                        <Box sx={{ fontWeight: 500, fontSize: '14px', pr: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                            <CheckCircleOutlineIcon sx={{ pr: 1, color: '#d93e45' }} /> Trolley Bag (55 x 40 x 23cm, max 10kg )
                                        </Box>
                                    </Grid>
                                    <Grid item>
                                        <Box sx={{ fontWeight: 500, fontSize: '14px', pr: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                            <CheckCircleOutlineIcon sx={{ pr: 1, color: '#d93e45' }} /> Priority Boarding
                                        </Box>
                                    </Grid>
                                    <Grid item>
                                        <Box sx={{ fontWeight: 500, fontSize: '14px', pr: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                                            <CheckCircleOutlineIcon sx={{ pr: 1, color: '#d93e45' }} /> Priority check-in desk
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ fontSize: '12px', fontWeight: 300 }}>
                                <Typography sx={{ color: '#d93e45', fontSize: '12px', fontWeight: 600 }}>Details</Typography>
                            </Box>
                            <Box>
                                <Grid sx={{ textAlign: 'center', py: 2 }} spacing={2} container>
                                    <Grid item>
                                        <Box sx={{ fontWeight: 500, fontSize: '14px', px: 5, py: 1 }}>
                                            Budapest
                                        </Box>
                                        <Box sx={{ fontWeight: 700, fontSize: '14px', borderRadius: '20px', border: '1px solid #333', p: 1 }}>
                                            3650 Ft
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Paper>
                </Container>

            </Box>

        </>
    );
}

export default ExtraForBooking;
